import React, { useState } from "react";
import { UNIT_PRESETS, isPresetUnit } from "../lib/units";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export default function UnitSelect({ value, onChange, testid }) {
  const [custom, setCustom] = useState(value != null && value !== "" && !isPresetUnit(value));
  const sel = custom ? "altro" : isPresetUnit(value) ? value : "corpo";
  const pick = (v) => {
    if (!v || v === sel) return;
    if (v === "altro") { setCustom(true); onChange(""); } else { setCustom(false); onChange(v); }
  };
  return (
    <div className="flex gap-1.5 min-w-0">
      <Select value={sel} onValueChange={pick}>
        <SelectTrigger data-testid={testid} className={`min-w-0 ${custom ? "w-24 shrink-0" : "w-full"}`}><SelectValue /></SelectTrigger>
        <SelectContent>
          {UNIT_PRESETS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
          <SelectItem value="altro">Altro…</SelectItem>
        </SelectContent>
      </Select>
      {custom && (
        <Input data-testid={`${testid}-custom`} value={isPresetUnit(value) ? "" : value || ""} maxLength={24} placeholder="es. rotolo" autoFocus
          onChange={(e) => onChange(e.target.value)} className="min-w-0 flex-1" />
      )}
    </div>
  );
}
